import _ from 'lodash'
import { FETCH_SPLITTED_SUB_ORDERS } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_SPLITTED_SUB_ORDERS:
      return action.payload
    default:
      return state
  }
}
